
import { useEffect, useRef, useState } from "react";
import "./style.css"
import { addCurrentThemeClassToEle } from "@/utils";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

type ExpandableTextProps = {
    bgColor: string;
    html: string;
    bulletIcon: string | null;
};

function injectBulletIcons(html: string, bulletIcon: string | null): string {
    if (!bulletIcon || !html.includes("<li>")) return html;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const listItems = doc.querySelectorAll("li");

    listItems.forEach((li) => {
        li.classList.add("readMoveUpdatedLi");
        const img = doc.createElement("img");
        img.src = bulletIcon;
        img.alt = "bullet";
        img.classList.add("readMoveUpdatedLi_icon");
        li.prepend(img);
    });

    return doc.body.innerHTML;
}

export default function ReadMoreCom({ html, bgColor, bulletIcon }: ExpandableTextProps) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isClamped, setIsClamped] = useState(false);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const enhancedHTML = injectBulletIcons(html, bulletIcon);
    // console.log(enhancedHTML)
    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const checkClamping = () => {
            const { scrollHeight, clientHeight } = el;
            setIsClamped(scrollHeight > clientHeight);
        };

        checkClamping();

        const observer = new ResizeObserver(checkClamping);
        observer.observe(el);
        return () => observer.disconnect();
    }, [enhancedHTML]);

    return (
        <div
            id="readMoreCom"
            className={`relative w-full leading-relaxed ${addCurrentThemeClassToEle(currentTheme, 'favViewMain')}`}>
            {!isExpanded ? (
                <div className="relative">
                    <div
                        ref={contentRef}
                        className="line-clamp-3 overflow-hidden relative"
                        dangerouslySetInnerHTML={{ __html: enhancedHTML }}
                    />
                    {isClamped && (
                        <div
                            className="absolute bottom-0 right-0 pl-1"
                        >
                            <span className="text-gray-600 mr-1">...</span>
                            <button
                                className="readMoreBtn"
                                onClick={() => setIsExpanded(true)}
                            >
                                Read more
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <div>
                    <div dangerouslySetInnerHTML={{ __html: enhancedHTML }} />
                    <button
                        className="text-[#0580FC]"
                        onClick={() => setIsExpanded(false)}
                    >
                        Read less
                    </button>
                </div>
            )}
        </div>
    );
}
